export default __webpack_public_path__ + "171718d09331a800f7ca400c72995ba1.svg";